(function () {
  'use strict';

  var root = document.getElementById('wm-ai-assistant');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  var drawer = root.querySelector('.wm-ai__drawer');
  var consentStep = root.querySelector('[data-wm-ai-step="consent"]');
  var conversationStep = root.querySelector('[data-wm-ai-step="conversation"]');
  var consent = root.querySelector('[data-wm-ai-consent]');
  var startButtons = Array.prototype.slice.call(root.querySelectorAll('[data-wm-ai-start]'));
  var statusText = root.querySelector('[data-wm-ai-status]');
  var messages = root.querySelector('[data-wm-ai-messages]');
  var errorBox = root.querySelector('[data-wm-ai-error]');
  var errorText = root.querySelector('[data-wm-ai-error-text]');
  var composer = root.querySelector('[data-wm-ai-form]');
  var input = root.querySelector('[data-wm-ai-input]');
  var sendButton = root.querySelector('[data-wm-ai-send]');
  var muteButton = root.querySelector('[data-wm-ai-mute]');
  var endButton = root.querySelector('[data-wm-ai-end]');
  var newButton = root.querySelector('[data-wm-ai-new]');
  var retryButton = root.querySelector('[data-wm-ai-retry]');
  var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-wm-ai-close]'));

  var conversation = null;
  var sdkPromise = null;
  var lastFocus = null;
  var selectedMode = null;
  var muted = false;
  var ending = false;
  var runId = 0;

  function clarityEvent(name) {
    try {
      if (typeof window.clarity === 'function') window.clarity('event', name);
    } catch (ignore) {}
  }

  function emit(name, detail) {
    clarityEvent(name);
    try {
      window.dispatchEvent(new CustomEvent('wm:ai-' + name.replace(/^wm_ai_/, ''), {
        detail: detail || {}
      }));
    } catch (ignore) {}
  }

  function setStatus(label, state) {
    statusText.textContent = label;
    root.dataset.status = state || '';
  }

  function setComposerEnabled(enabled) {
    input.disabled = !enabled;
    sendButton.disabled = !enabled;
  }

  function appendMessage(role, text) {
    if (!text) return;
    var item = document.createElement('div');
    item.className = 'wm-ai__message wm-ai__message--' + (role === 'user' ? 'user' : 'agent');
    item.textContent = text;
    messages.appendChild(item);
    messages.scrollTop = messages.scrollHeight;
  }

  function showConsent() {
    consentStep.hidden = false;
    conversationStep.hidden = true;
    consent.checked = false;
    startButtons.forEach(function (button) { button.disabled = true; });
    root.dataset.status = '';
  }

  function showConversation() {
    consentStep.hidden = true;
    conversationStep.hidden = false;
  }

  function resetConversationUi() {
    messages.textContent = '';
    errorBox.hidden = true;
    errorText.textContent = 'Please try again or contact us directly.';
    input.value = '';
    setComposerEnabled(false);
    muteButton.hidden = true;
    muteButton.textContent = 'Mute microphone';
    endButton.hidden = false;
    endButton.disabled = false;
    newButton.hidden = true;
    muted = false;
  }

  function showError(message, code) {
    setStatus('Connection unavailable', 'error');
    setComposerEnabled(false);
    endButton.hidden = true;
    newButton.hidden = false;
    errorText.textContent = message || 'Please try again or contact us directly.';
    errorBox.hidden = false;
    emit('wm_ai_session_failed', { code: code || 'unknown', mode: selectedMode || 'unknown' });
  }

  function friendlyError(error) {
    var name = error && error.name ? error.name : '';
    var raw = error && error.message ? error.message : String(error || '');
    if (name === 'NotAllowedError' || /permission|notallowed/i.test(raw)) {
      return {
        code: 'microphone_permission',
        text: 'Microphone access was not allowed. You can try again and allow access, or use text chat instead.'
      };
    }
    if (!navigator.onLine) {
      return { code: 'offline', text: 'You appear to be offline. Reconnect to the internet and try again.' };
    }
    if (/timeout/i.test(raw)) {
      return { code: 'timeout', text: 'The assistant took too long to connect. Please try again.' };
    }
    if (/microphone is not supported/i.test(raw)) {
      return { code: 'microphone_unsupported', text: 'Voice is not supported in this browser. Please use text chat instead.' };
    }
    return { code: 'connection', text: 'The assistant could not connect. Please try again or contact Wine Majesty directly.' };
  }

  function loadSdk() {
    if (window.ElevenLabsClient && window.ElevenLabsClient.Conversation) {
      return Promise.resolve(window.ElevenLabsClient);
    }
    if (sdkPromise) return sdkPromise;

    sdkPromise = new Promise(function (resolve, reject) {
      var settled = false;
      var script = document.createElement('script');
      var timeout = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error('SDK load timeout'));
      }, 20000);

      script.src = root.dataset.sdkUrl;
      script.async = true;
      script.dataset.wmAiSdk = '1.23.0';
      script.onload = function () {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        if (window.ElevenLabsClient && window.ElevenLabsClient.Conversation) {
          emit('wm_ai_sdk_loaded', { version: '1.23.0' });
          resolve(window.ElevenLabsClient);
        } else {
          reject(new Error('SDK global missing'));
        }
      };
      script.onerror = function () {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        reject(new Error('SDK load failed'));
      };
      document.head.appendChild(script);
    }).catch(function (error) {
      sdkPromise = null;
      throw error;
    });

    return sdkPromise;
  }

  async function stopConversation(reason) {
    runId += 1;
    ending = true;
    var active = conversation;
    conversation = null;
    setComposerEnabled(false);
    endButton.disabled = true;
    if (active) {
      try { await active.endSession(); } catch (ignore) {}
    }
    ending = false;
    if (reason === 'closed') {
      resetConversationUi();
      showConsent();
      return;
    }
    setStatus('Conversation ended', 'disconnected');
    endButton.hidden = true;
    newButton.hidden = false;
    emit('wm_ai_session_ended', { mode: selectedMode || 'unknown' });
  }

  function openDrawer() {
    if (root.classList.contains('is-open')) return true;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wm-ai-open');
    window.setTimeout(function () {
      var close = root.querySelector('.wm-ai__close');
      if (close) close.focus();
    }, 0);
    emit('wm_ai_drawer_opened');
    return true;
  }

  async function closeDrawer() {
    root.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wm-ai-open');
    if (conversation || root.dataset.status === 'connecting') await stopConversation('closed');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    emit('wm_ai_drawer_closed');
  }

  async function startConversation(mode) {
    if (!consent.checked) return;
    selectedMode = mode;
    var currentRun = ++runId;
    ending = false;
    resetConversationUi();
    showConversation();
    setStatus(mode === 'voice' ? 'Requesting microphone access...' : 'Connecting text chat...', 'connecting');
    emit('wm_ai_consent_accepted', { mode: mode });

    try {
      if (mode === 'voice' && (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia)) {
        throw new Error('Microphone is not supported by this browser');
      }

      var sdk = await loadSdk();
      if (currentRun !== runId) return;

      var created = await sdk.Conversation.startSession({
        agentId: root.dataset.agentId,
        connectionType: mode === 'voice' ? 'webrtc' : 'websocket',
        textOnly: mode === 'text',
        dynamicVariables: {
          page_context: root.dataset.pageContext || 'The visitor is on winemajesty.com.'
        },
        overrides: {
          agent: { firstMessage: root.dataset.firstMessage },
          conversation: { textOnly: mode === 'text' }
        },
        onConnect: function (event) {
          if (currentRun !== runId) return;
          setStatus(mode === 'voice' ? 'Connected. You can speak now.' : 'Connected', 'connected');
          setComposerEnabled(true);
          muteButton.hidden = mode !== 'voice';
          emit('wm_ai_session_connected', {
            mode: mode,
            conversationId: event && event.conversationId ? event.conversationId : ''
          });
        },
        onStatusChange: function (event) {
          if (currentRun !== runId || !event) return;
          if (event.status === 'connecting') setStatus('Connecting...', 'connecting');
          if (event.status === 'disconnecting') setStatus('Ending conversation...', 'disconnecting');
        },
        onModeChange: function (event) {
          if (currentRun !== runId || mode !== 'voice' || !event) return;
          if (event.mode === 'speaking') setStatus('AI assistant is speaking', 'speaking');
          if (event.mode === 'listening') setStatus('Listening', 'connected');
        },
        onMessage: function (event) {
          if (currentRun !== runId || !event) return;
          appendMessage(event.role === 'user' || event.source === 'user' ? 'user' : 'agent', event.message);
        },
        onError: function (message, context) {
          if (currentRun !== runId) return;
          console.error('[WM AI] ElevenLabs session error', { message: message, context: context });
          var mapped = friendlyError(new Error(message || 'Session error'));
          showError(mapped.text, mapped.code);
        },
        onDisconnect: function (details) {
          if (currentRun !== runId || ending) return;
          conversation = null;
          setComposerEnabled(false);
          endButton.hidden = true;
          newButton.hidden = false;
          if (details && details.reason === 'error') {
            console.error('[WM AI] ElevenLabs disconnected', details);
            showError('The assistant lost its connection. Please try again or contact Wine Majesty directly.', 'disconnected');
          } else {
            setStatus('Conversation ended', 'disconnected');
          }
        }
      });

      if (currentRun !== runId || !root.classList.contains('is-open')) {
        try { await created.endSession(); } catch (ignore) {}
        return;
      }
      conversation = created;
    } catch (error) {
      if (currentRun !== runId) return;
      console.error('[WM AI] Could not start ElevenLabs session', error);
      var mapped = friendlyError(error);
      showError(mapped.text, mapped.code);
    }
  }

  window.wmOpenAI = openDrawer;

  document.addEventListener('click', function (event) {
    var open = event.target && event.target.closest ? event.target.closest('[data-wm-ai-open]') : null;
    if (!open) return;
    event.preventDefault();
    openDrawer();
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      closeDrawer();
    });
  });

  consent.addEventListener('change', function () {
    startButtons.forEach(function (button) { button.disabled = !consent.checked; });
  });

  startButtons.forEach(function (button) {
    button.addEventListener('click', function () { startConversation(button.dataset.wmAiStart); });
  });

  composer.addEventListener('submit', function (event) {
    event.preventDefault();
    var text = input.value.trim();
    if (!text || !conversation) return;
    try {
      conversation.sendUserMessage(text);
      input.value = '';
      input.focus();
    } catch (error) {
      console.error('[WM AI] Could not send message', error);
      showError('Your message could not be sent. Please try again.', 'send_failed');
    }
  });

  muteButton.addEventListener('click', function () {
    if (!conversation || selectedMode !== 'voice') return;
    muted = !muted;
    try {
      conversation.setMicMuted(muted);
      muteButton.textContent = muted ? 'Unmute microphone' : 'Mute microphone';
    } catch (error) {
      console.error('[WM AI] Could not change microphone state', error);
    }
  });

  endButton.addEventListener('click', function () { stopConversation('ended'); });
  newButton.addEventListener('click', function () {
    runId += 1;
    conversation = null;
    resetConversationUi();
    showConsent();
  });
  retryButton.addEventListener('click', function () {
    runId += 1;
    conversation = null;
    resetConversationUi();
    showConsent();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
  });
})();
